<template>
  <div class="mettingDetail">
    <back @change="back"/>
<!--    <detail-video :video-poster="videoPoster" :video-url="videoUrlUpdate" :data="dataInfo"/>-->
    <DetailVideoAl v-if="videoUrlUpdate" :video-poster="videoPoster" :video-url="videoUrlUpdate" :data="dataInfo"/>
    <detail-tab v-if="dataInfo.value5 && isVideoList" :video-list="videoList.length" :data="dataInfo.value5"/>
    <!--    介绍-->
    <detail-introduce :data="dataInfo"/>
    <!--    热度-->
    <detail-heat :data="dataInfo"/>
    <!--    开播提醒-->
    <detail-remind :data="dataInfo" v-if="dataInfo.liveurl"/>
    <!--    回放列表-->
    <detail-video-list v-if="dataInfo.value5 === '0' && videoList.length > 0" :video-list="videoList"
                       @change="getVideoUrl"/>
    <!--富文本    -->
    <detail-rich-text v-if="dataInfo.content !== ''" :data="dataInfo"/>
    <!--    问卷-->
    <detail-ques v-if="questionList.length > 0" :data="dataInfo" :question-list="questionList"/>
    <!--    投票-->
    <detail-vote v-if="voteList.length > 0" :data="dataInfo" :vote-list="voteList"/>
  </div>
</template>

<script>
import DetailVideo from '@/views/meetings/detail/DetailVideo'
import DetailVideoAl from '@/views/meetings/detail/DetailVideoAl'
import DetailTab from "@/views/meetings/detail/detailTab";
import DetailIntroduce from "@/views/meetings/detail/DetailIntroduce";
import DetailHeat from "@/views/meetings/detail/DetailHeat";
import DetailRemind from "@/views/meetings/detail/DetailRemind";
import DetailVideoList from "@/views/meetings/detail/DetailVideoList";
import DetailRichText from "@/views/meetings/detail/DetailRichText";
import DetailVote from "@/views/meetings/detail/DetailVote";
import DetailQues from "@/views/meetings/detail/DetailQuestionnaire";
import Back from "@/components/back/Back";
import SetPageTitle from "../../../common/js/get-page-title"
import GetPageTitle from "@/common/js/get-page-title";
import {wxShare} from "@/common/js/wx";
import HTTP from "@/common/js/http";
import {Api} from "@/api/api";

export default {
  name: "mettingDetail",
  components: {
    DetailVideoAl,
    Back,
    DetailQues,
    DetailVote,
    DetailRichText, DetailVideoList, DetailRemind, DetailHeat, DetailIntroduce, DetailTab, DetailVideo
  },
  data() {
    return {
      isAli: this.$route.params.type,
      videoPoster: '',
      videoUrlUpdate: '',
      dataInfo: {},
      questionList: [],
      voteList: [],
      videoList: [],
      isVideoList: false,
    }
  },
  created(){
    this.checkIsOpen()
  },
  mounted() {
    this.get()
    this.getQuestion()
    this.voteGet()
    this.userSignIn()
  },
  methods: {
    checkIsOpen(){
      let userId = localStorage.getItem('userId-school')
      let activityId = this.$route.params.id
      this.$http.get(this.$api.activity.get + activityId + '/' + userId).then(res => {
        let {code, data} = res
        if (code === 0) {
          this.dataInfo = data
          if(data.onoff===1){
            // 活动未启用
            this.$router.push({path: '/activeClose'})
            document.title = GetPageTitle(data.title)
          }
        }
      })
    },

    back() {
      if (window.history.length <= 1) {
        this.$router.push({path: '/meetings'})
        return false
      } else {
        this.$router.go(-1)
      }
    },
    getVideoUrl(data) {
      this.videoUrlUpdate = data.url
      this.videoPoster = data.image
      window.scrollTo(0, 0);
    },
    voteGet() {
      this.$http.get(this.$api.vote.list + this.$route.params.id).then(res => {
        let {code, data} = res
        if (code === 0) {
          this.voteList = data
        }
      })
    },
    getQuestion() {
      this.$http.get(this.$api.question.get + this.$route.params.id).then(res => {
        let {code, data} = res
        if (code === 0) {
          this.questionList = data
        }
      })
    },
    getVideo(aId) {
      this.$http.get(this.$api.activity.videoList + aId).then(res => {
        let {code, data, message} = res
        if (code === 0) {
          this.isVideoList = true
          this.videoList = data
          if (data[0]) {
            this.videoUrlUpdate = data[0].url
            this.videoPoster = data[0].image
          }
        } else {
          this.$toast(message)
        }
      })
    },
    get(aId) {
      let userId = localStorage.getItem('userId-school')
      let id = aId ? aId : this.$route.params.id
      this.$http.get(this.$api.activity.get + id + '/' + userId).then(res => {
        let {code, data} = res
        if (code === 0) {
          if (data.value3) {
            this.get(data.value3.split('ID::')[1])
            return
          }
          if (data.liveurl) {
            this.videoUrlUpdate = data.liveurl
          } else {
            this.getVideo(data.id)
          }
          if (data.popup && !data.look) {
            this.$dialog.confirm({
              confirmButtonColor: '#0090C5',
              confirmButtonText: '是',
              cancelButtonText: '否',
              title: data.popupcontent,
            })
                .then(() => {
                  // on confirm
                  this.updateUserLook('是')
                })
                .catch(() => {
                  // on cancel
                  this.updateUserLook('否')
                });
          }
          this.dataInfo = data
          document.title = GetPageTitle(data.title)
          // wxShare(data.title, data.name, data.image, this.$route.params.id)
          window.wx.ready(() => {
            window.wx.onMenuShareAppMessage({
              title: data.title || null, // 分享标题
              desc: data.name || null, // 分享描述
              link: window.location.href, // 分享链接；在微信上分享时，该链接的域名必须与企业某个应用的可信域名一致
              imgUrl: data.image || null, // 分享图标
              success: function () {
                // 用户确认分享后执行的回调函数
                console.log('分享承成功 id：' + id)
                if (id) {
                  let userId = localStorage.getItem('userId-school')
                  let params = {
                    activityid: id,
                    fromid: userId
                  }
                  HTTP.post(Api.forwardSave, params).then(res => {
                    console.log(res);
                  })
                }
              },
              cancel: function () {
                // 用户取消分享后执行的回调函数
              }
            })
          })
        }
      })
    },
    userSignIn() {
      let params = {
        activityid: this.$route.params.id,
        userid: localStorage.getItem('userId-school')
      }
      this.$http.post(this.$api.conference.signin, params)
    },
    updateUserLook(val) {
      let params = {
        activityid: this.$route.params.id,
        activityname: this.dataInfo.title,
        popupcontent: val,
        userid: localStorage.getItem('userId-school'),
        username: localStorage.getItem('userName-school')
      }
      this.$http.post(this.$api.activity.userLookUpdate, params).then(res => {
        console.log(res);
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.mettingDetail {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  padding-bottom: 200px;
  background: #FFFFFF;
}

</style>
